export const HTTP_BUILDINGS_FETCHING = "HTTP_BUILDINGS_FETCHING";
export const HTTP_BUILDINGS_SUCCESS = "HTTP_BUILDINGS_SUCCESS";
export const HTTP_BUILDINGS_FAILED = "HTTP_BUILDINGS_FAILED";

export const HTTP_LOCATION_FETCHING = "HTTP_LOCATION_FETCHING";
export const HTTP_LOCATION_SUCCESS = "HTTP_LOCATION_SUCCESS";
export const HTTP_LOCATION_FAILED = "HTTP_LOCATION_FAILED";

export const HTTP_ROOM_FETCHING = "HTTP_ROOM_FETCHING";
export const HTTP_ROOM_SUCCESS = "HTTP_ROOM_SUCCESS";
export const HTTP_ROOM_FAILED = "HTTP_ROOM_FAILED";

export const HTTP_POSITION_FETCHING = "HTTP_POSITION_FETCHING";
export const HTTP_POSITION_SUCCESS = "HTTP_POSITION_SUCCESS";
export const HTTP_POSITION_FAILED = "HTTP_POSITION_FAILED";

export const HTTP_DEPARTMENT_FETCHING = "HTTP_DEPARTMENT_FETCHING";
export const HTTP_DEPARTMENT_SUCCESS = "HTTP_DEPARTMENT_SUCCESS";
export const HTTP_DEPARTMENT_FAILED = "HTTP_DEPARTMENT_FAILED";

export const HTTP_TITLE_FETCHING = "HTTP_TITLE_FETCHING";
export const HTTP_TITLE_SUCCESS = "HTTP_TITLE_SUCCESS";
export const HTTP_TITLE_FAILED = "HTTP_TITLE_FAILED";

export const HTTP_POSITION_MEETING_FETCHING = "HTTP_POSITION_MEETING_FETCHING";
export const HTTP_POSITION_MEETING_SUCCESS = "HTTP_POSITION_MEETING_SUCCESS";
export const HTTP_POSITION_MEETING_FAILED = "HTTP_POSITION_MEETING_FAILED";

export const HTTP_GROUP_NAME_FETCHING = "HTTP_GROUP_NAME_FETCHING";
export const HTTP_GROUP_NAME_SUCCESS = "HTTP_GROUP_NAME_SUCCESS";
export const HTTP_GROUP_NAME_FAILED = "HTTP_GROUP_NAME_FAILED";

export const HTTP_GROUP_ITEM_FETCHING = "HTTP_GROUP_ITEM_FETCHING";
export const HTTP_GROUP_ITEM_SUCCESS = "HTTP_GROUP_ITEM_SUCCESS";
export const HTTP_GROUP_ITEM_FAILED = "HTTP_GROUP_ITEM_FAILED";